import { Component, OnInit } from '@angular/core';
import { AgmCoreModule } from '@agm/core';
// import { } from '../../assets/images/leaflet/marker-icon-2x.png'
@Component({
  selector: 'app-track-all-packages',
  templateUrl: './track-all-packages.component.html',
  styleUrls: ['./track-all-packages.component.sass']
})
export class TrackAllPackagesComponent implements OnInit {
  lat = 29.237529;
  lng = 74.751059;
  icon="../../assets/images/leaflet/marker-icon.png"

  currentLatLong = [
    {  currentLat : 29.2660 , currentLng : 74.6858 },
    {  currentLat : 29.3709 , currentLng : 75.1246 },
    {  currentLat : 29.6183 , currentLng : 73.8750 }
  ]

  allOriginDestinations =[
    {   origin  : { lat: 29.229297, lng: 74.798573 ,  },  destination : { lat: 29.61775, lng: 74.289017 } , currentLat : 29.2660 , currentLng : 74.6858 },  // Nohar to HMG
    {   origin  : { lat: 29.101709, lng: 75.171112 ,  },  destination : { lat: 29.533593, lng: 75.017703 } , currentLat : 29.3709 , currentLng : 75.1246 },  // Bhadra to Sirsa
    {   origin  : { lat: 29.320198, lng: 73.900709 ,  },  destination : { lat: 29.92, lng: 73.88 } , currentLat : 29.6183 , currentLng : 73.8750 },  // Suratgarh to GNGR
   ]



   renderOptions = {
    suppressMarkers: true
  };


  constructor() { }

  ngOnInit(): void {
  }


  next(){
    let data = [
      {  currentLat : 29.2566 , currentLng : 74.4049 },
      {  currentLat : 29.4637, currentLng : 75.0817},
      {  currentLat : 29.8043 , currentLng : 73.8581 }
    ]

    this.currentLatLong = [];
    this.currentLatLong = data;

  }


  back(){
    let data = [
      {  currentLat : 29.2660 , currentLng : 74.6858 },
    {  currentLat : 29.3709 , currentLng : 75.1246 },
    {  currentLat : 29.6183 , currentLng : 73.8750 }
    ]

    this.currentLatLong = [];
    this.currentLatLong = data;

  }

}
